const notificationlogs = {
	title: "Varslingshistorikk",
	type: "Type",
	slug: "Slug",
	subject: "E-postemne / SMS-melding",
	message: "Melding",
	recipient: "Mottaker",
	date_sent: "Dato sendt",
	status: "Status",
	sender: "Avsender",
	system_triggered: "Systemgenerert",
};
export default notificationlogs;